import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../service/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private readonly authService: AuthService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (this.isAuthPublicEndpoint(request.url)) {
      return next.handle(request);
    }

    const token = this.authService.getAccessToken();

    if (!token || request.headers.has('Authorization')) {
      return next.handle(request);
    }

    const clonedRequest = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });

    return next.handle(clonedRequest);
  }

  private isAuthPublicEndpoint(url: string): boolean {
    const normalizedUrl = url.toLowerCase();
    return (
      normalizedUrl.includes('/api/pwa/auth/login') ||
      normalizedUrl.includes('/api/pwa/auth/register') ||
      normalizedUrl.includes('/api/pwa/auth/refresh')
    );
  }
}
